import type { SVGProps } from 'react';
const SvgNavWallet = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    height={24}
    fill="none"
    width={24}
    {...props}
  >
    <path
      d="M5 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 3 19V5q0-.824.587-1.412A1.93 1.93 0 0 1 5 3h14q.824 0 1.413.587Q21 4.176 21 5v2.5h-2V5H5v14h14v-2.5h2V19q0 .824-.587 1.413A1.93 1.93 0 0 1 19 21zm8-4q-.825 0-1.412-.587A1.93 1.93 0 0 1 11 15V9q0-.825.588-1.412A1.93 1.93 0 0 1 13 7h7q.824 0 1.413.588Q22 8.175 22 9v6q0 .824-.587 1.413A1.93 1.93 0 0 1 20 17zm7-2V9h-7v6zm-4-1.5q.625 0 1.063-.437.437-.438.437-1.063t-.437-1.062A1.45 1.45 0 0 0 16 10.5q-.625 0-1.062.438A1.45 1.45 0 0 0 14.5 12q0 .624.438 1.063.437.437 1.062.437"
      fill="currentColor"
    />
  </svg>
);
export default SvgNavWallet;
